import styled from 'styled-components';

const IconInputField = styled.div`
  position: relative;
  .startIcon {
    position: absolute;
    top: 14px;
    left: 14px;
  }
  .emailIcon {
    position: absolute;
    top: 20px;
    left: 14px;
  }
  .passwordIcon {
    position: absolute;
    top: 14px;
    right: 14px;
    cursor: pointer;
  }
  input {
    padding-right: 40px !important;
  }
`;
const IconInputFields = styled.div`
  position: relative;
  .startIcon {
    position: absolute;
    top: 14px;
    left: 14px;
  }
  .emailIcon {
    position: absolute;
    top: 20px;
    left: 14px;
  }
  .passwordIcon {
    position: absolute;
    top: 14px;
    right: 14px;
    cursor: pointer;
  }
  input {
    padding-left: 14px;
  }
`;

export { IconInputField, IconInputFields };
